/**
 * 시스템 > 장비관리 > 장비그룹 편집 컴포넌트 Store
 *
 * @since 2018-03-12
 * @author devp010
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  devicesUrl: `${apiPrefix}/devices`,
  imgUrl: `${apiPrefix}/devices/img`,
  // monInhritUrl: `${apiPrefix}/devices/mon-inhrit`,
  bgImage: null,
  // 그룹 설정/공통 설정
  deviceGroupInfo: {
    device_type: 0,
    parent_device_id: 0,
    device_id: 0,
    device_uname: '',
    device_desc: '',
    device_mon_event_inhrit_yn: 0,
    device_mon_yn: 0
  }
})

export const mutations = {
  initDeviceGroupInfo (state) {
    state.deviceGroupInfo.device_type = 0
    state.deviceGroupInfo.parent_device_id = 0
    state.deviceGroupInfo.device_id = 0
    state.deviceGroupInfo.device_uname = ''
    state.deviceGroupInfo.device_desc = ''
    state.deviceGroupInfo.device_mon_event_inhrit_yn = 0
    state.deviceGroupInfo.device_mon_yn = 0
  },
  setDeviceGroupInfo (state, data) {
    state.deviceGroupInfo.device_type = data.device_type
    state.deviceGroupInfo.parent_device_id = data.parent_device_id
    state.deviceGroupInfo.device_id = data.device_id
    state.deviceGroupInfo.device_uname = data.device_uname
    state.deviceGroupInfo.device_desc = data.device_desc
    state.deviceGroupInfo.device_mon_event_inhrit_yn = data.device_mon_event_inhrit_yn
    state.deviceGroupInfo.device_mon_yn = data.device_mon_yn
  }
}

export const actions = {
  // setDeviceId ({commit, state}, payload) {
  async getGroupInfo ({commit, state}, id) {
    const res = await this.$axios.$get(`${state.devicesUrl}/${id}`)
    if (res.code === 'ok') {
      commit('setDeviceGroupInfo', res.result[0])
    }
    return res
  },
  // 미사용으로 추측됨 (2020-04-06)
  // async getImg ({commit, state}) {
  //   const res = await this.$axios.$get(`${state.imgUrl}/${state.deviceGroupInfo.device_id}`)
  //   if (res.code === 'ok') {
  //     state.bgImage = res.result
  //   } else {
  //     state.bgImage = `${state.imgUrl}/${state.deviceGroupInfo.device_id}`
  //   }
  //   return res
  // },
  // async setBgImg ({commit, state}) {
  //   const res = await this.$axios.$put(`${state.imgUrl}/${state.deviceGroupInfo.device_id}`)
  //   if (res.code === 'ok') {
  //     state.bgImage = res.result
  //   } else {
  //     state.bgImage = `${state.imgUrl}/${state.deviceGroupInfo.device_id}`
  //   }
  //   return res
  // },
  async delBgImg ({commit, state}) {
    const res = await this.$axios.$delete(`${state.imgUrl}/${state.deviceGroupInfo.device_id}`)
    return res
  },
  async setMonInhrit ({commit, dispatch, state}) {
    const res = await this.$axios.$put(`${state.devicesUrl}/mon-inhrit/${state.deviceGroupInfo.device_id}/${state.deviceGroupInfo.device_mon_event_inhrit_yn}`, null, {loading: false, successAlert: false})
    if (res.code === 'ok') {
      return dispatch('getGroupInfo', state.deviceGroupInfo.device_id)
    }
    return res
  }
}

export const getters = {
}

export const strict = false
